import React, { useState } from "react";
import "./HeaderPublic.css";

export default function HeaderPublic() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Navigation JSX for reuse
  const navLinks = (
    <>
      {/* ABOUT dropdown */}
      <div className="nav-item">
        <a href="https://mongrel.live/about" className="nav-link" target="_blank" rel="noopener noreferrer">
          about
        </a>
        <div className="dropdown">
          <a href="https://mongrel.live/about" target="_blank" rel="noopener noreferrer">
            mongrel
          </a>
          <a href="https://mongrel.live/blog" target="_blank" rel="noopener noreferrer">
            blog
          </a>
          <a href="https://mongrel.live/references" target="_blank" rel="noopener noreferrer">
            references
          </a>
        </div>
      </div>

      {/* SERVICES dropdown */}
      <div className="nav-item">
        <a href="https://mongrel.live/monetise" className="nav-link" target="_blank" rel="noopener noreferrer">
          services
        </a>
        <div className="dropdown">
          <a href="https://mongrel.live/monitor" target="_blank" rel="noopener noreferrer">
            monitor
          </a>
          <a href="https://mongrel.live/predict" target="_blank" rel="noopener noreferrer">
            predict
          </a>
          <a href="https://mongrel.live/monetise" target="_blank" rel="noopener noreferrer">
            monetise
          </a>
        </div>
      </div>

      {/* RESEARCH */}
      <a href="https://mongrel.live/research" target="_blank" rel="noopener noreferrer" className="nav-link">
        research
      </a>

      {/* PLATFORM dropdown */}
      <div className="nav-item">
        <a href="https://mongrel.live/demo" className="nav-link" target="_blank" rel="noopener noreferrer">
          platform
        </a>
        <div className="dropdown">
          <a href="https://mongrel.live/demo" target="_blank" rel="noopener noreferrer">
            request demo
          </a>
        </div>
      </div>

      {/* CONTACT */}
      <a href="https://mongrel.live/contact" target="_blank" rel="noopener noreferrer" className="nav-link">
        contact
      </a>
    </>
  );

  return (
    <header className="public-header">
      <div className="public-header-inner">
        {/* Logo */}
        <a href="https://mongrel.live" className="public-logo">
          <img src="/mongrel-logo.png" alt="mongrel" />
        </a>

        {/* Hamburger for mobile */}
        <button
          className={`hamburger-menu${mobileMenuOpen ? ' open' : ''}`}
          aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          onClick={() => setMobileMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        {/* Desktop Navigation */}
        <nav className="public-nav">
          {navLinks}
        </nav>
      </div>

      {/* Mobile Navigation Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)}>
          <nav className="mobile-nav" onClick={e => e.stopPropagation()}>
            <button className="close-mobile-nav" aria-label="Close navigation menu" onClick={() => setMobileMenuOpen(false)}>
              &times;
            </button>
            {navLinks}
          </nav>
        </div>
      )}
    </header>
  );
}
